import { render } from "./DynamicsDialogue.vue?vue&type=template&id=2abc82ee&scoped=true"
import script from "./DynamicsDialogue.vue?vue&type=script&lang=js"
export * from "./DynamicsDialogue.vue?vue&type=script&lang=js"

import "./DynamicsDialogue.vue?vue&type=style&index=0&id=2abc82ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2abc82ee"]])

export default __exports__